// extracted by mini-css-extract-plugin
export default {"header":"ButtonPaneCollapse_header__uhdQp","title":"ButtonPaneCollapse_title__VybMM","body":"ButtonPaneCollapse_body__6nTVI","bodyOpen":"ButtonPaneCollapse_bodyOpen__0D3TM"};